import { render, staticRenderFns } from "./GarageDoorDescription.vue?vue&type=template&id=6ea2cba4&scoped=true"
import script from "./GarageDoorDescription.vue?vue&type=script&lang=ts"
export * from "./GarageDoorDescription.vue?vue&type=script&lang=ts"
import style0 from "./GarageDoorDescription.vue?vue&type=style&index=0&id=6ea2cba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea2cba4",
  null
  
)

export default component.exports